import { useState, useEffect } from 'react';
import { FeatureFlag } from '@studio/feature-flag-types';
import { useDevTools, useFeatureFlags } from 'studio5/contexts';

export default function useFeature(
  name: FeatureFlag | null,
  defaultValue = false
) {
  const { has, get } = useDevTools();
  const { getFeature } = useFeatureFlags();

  const [value, setValue] = useState<boolean | null>(null);

  useEffect(() => {
    if (name === null) return;

    if (has(name)) {
      setValue(get(name));
    } else {
      getFeature(name, defaultValue).then(setValue);
    }
  }, []);

  return value;
}
